import EthereumIcon from "../../assets/images/EthereumIcon.svg";
import PolygonBadge from "../../assets/images/PolygonBadge.svg";
import AvalancheBadge from "../../assets/images/AvalancheBadge.svg";
import BinanceBadge from "../../assets/images/BinanceSmartChainBadge.svg";
import ArbitrumBadge from "../../assets/images/arbitrum-arb-logo.svg";
import BaseBadge from "../../assets/images/base-logo.svg";
import SolanaBadge from "../../assets/images/solana-sol-logo.svg";
import PartisiaBadge from "../../assets/images/partisia-logo.svg";
import OptimismBadge from '../../assets/images/optimism-ethereum-op-logo.svg';

export const getNetworkBadge = (chain: string) => {
  switch (chain.toUpperCase()) {
    case "ETHEREUM":
      return EthereumIcon;
    case "BSC":
      return BinanceBadge;
    case "POLYGON":
      return PolygonBadge;
    case "AVALANCHE":
      return AvalancheBadge;
    case "ARBITRUM":
      return ArbitrumBadge;
    case "SOLANA":
      return SolanaBadge;
    case "PARTISIA":
      return PartisiaBadge;
    case "BASE":
      return BaseBadge;
    case "OPTIMISM":
      return OptimismBadge;
    default:
      return undefined;
  }
};